import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';

export const BoxStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: '8px',
  padding: '16px',
  backgroundColor: theme.palette.tableHead,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '4px',
}));

export const AvatarWrapperStyled = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  alignItems: 'flex-start',
});
